module.exports = __webpack_public_path__ + "img/4.db7f5246.png";